module.exports = __webpack_public_path__ + "img/investment.5a42b768.svg";